import {
    MORE_SUBSTITUTES_LOADED,
    SUBSTITUES_ACTIVE_FILTER_CHANGE,
    SUBSTITUES_LOADED,
    SUBSTITUES_LOADING,
    SUBSTITUES_SEARCH_VALUE,
    SUBSTITUES_SORT
} from '../store/actionTypes';

import {createSelector} from 'reselect';
import {LOADING_STATUS} from 'utils/constants';
import {
    STATUS_FILTER,
    StatusFilterValue,
    SubstitutesAction,
    SubstitutesForRender,
    SubstitutesPage,
    SubstitutesSort,
    SubstitutesState
} from 'types/substitutes';

const EMPTY_SUBSTITUTES: SubstitutesPage = {
    page: 1,
    rows: [],
    records: 0
};

export const DEFAULT_STATE: SubstitutesState = {
    activeFilter: STATUS_FILTER.ALL,
    loadingStatus: LOADING_STATUS.LOADING,
    substitutes: EMPTY_SUBSTITUTES,
    searchValue: "",
    sort: {
        fieldName: "",
        sortOrder: true
    }
};

export const getSubstitutesForRender = createSelector(
    [getSubstitutes],
    (substitutes: SubstitutesPage): SubstitutesForRender => {
        return {
            allSubstitutes: substitutes.rows,
            records: substitutes.records,
            page: substitutes.page
        };
    }
);

export default function SubstitutesReducer(state: SubstitutesState = DEFAULT_STATE, action: SubstitutesAction): SubstitutesState {
    switch (action.type) {

        case SUBSTITUES_LOADING:
            return Object.assign({}, state, {
                loadingStatus: LOADING_STATUS.LOADING,
                // keep the {page, rows, records} shape, otherwise selectors read undefined
                substitutes: EMPTY_SUBSTITUTES
            });

        case SUBSTITUES_LOADED:
            return Object.assign({}, state, {
                loadingStatus: LOADING_STATUS.DONE,
                substitutes: action.data as SubstitutesPage
            });

        case SUBSTITUES_ACTIVE_FILTER_CHANGE:
            return Object.assign({}, state, {activeFilter: action.data as StatusFilterValue});

        case SUBSTITUES_SEARCH_VALUE:
            return Object.assign({}, state, {searchValue: action.data as string});

        case SUBSTITUES_SORT:
            return Object.assign({}, state, {sort: action.data as SubstitutesSort});

        case MORE_SUBSTITUTES_LOADED: {
            const loaded = action.data as SubstitutesPage;
            return Object.assign({}, state, {
                substitutes: {
                    ...state.substitutes,
                    // a page past the first extends the list rather than replacing it
                    rows: state.substitutes.rows.concat(loaded.rows),
                    page: loaded.page
                }
            });
        }

        default:
            return state;
    }
}

export function getActiveFilter(state: SubstitutesState): StatusFilterValue {
    return state.activeFilter;
}

export function getSearchValue(state: SubstitutesState): string {
    return state.searchValue;
}

export function getSubstitutes(state: SubstitutesState): SubstitutesPage {
    return state.substitutes;
}

export function getSorting(state: SubstitutesState): SubstitutesSort {
    return state.sort;
}

export function getLoadingStatus(state: SubstitutesState): number {
    return state.loadingStatus;
}
